import '../PublicPage.css';

export default function SpainItineraryPage() {
    return (
        <div className="public-page spain-page">
            <header className="public-hero" style={{
                backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/images/photo-1543722530-d2c3201371e7.jpg',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white'
            }}>
                <div className="public-hero-content">
                    <h1 style={{ color: 'white' }}>Spain: Culture, Sun, and Tapas</h1>
                    <p style={{ color: 'rgba(255,255,255,0.9)' }}>From the streets of Madrid to the beaches of Barcelona.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Spain?</h3>
                            <p>Spain is a vibrant country with a rich tapestry of cultures, world-class museums, and incredible food. Whether you want to dance under the sun or explore historic cathedrals, Spain has it all.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: 7-Day Spanish Highlight</h3>
                            <p>Barcelona and Madrid. The perfect mix of modern life, stunning architecture, and deep history.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Top Destinations</h2>
                    <ul className="benefits-list">
                        <li><strong>Barcelona</strong>: Gaudi's Sagrada Familia and the lively Gothic Quarter.</li>
                        <li><strong>Madrid</strong>: The artistic heart with the Prado Museum and Royal Palace.</li>
                        <li><strong>Seville</strong>: The soulful home of Flamenco and the grand Alcázar.</li>
                        <li><strong>Mallorca</strong>: Crystal-clear waters and charming mountain villages.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready to plan your Spain trip?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI create a personalized itinerary for you in seconds.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan a 7-day trip to Spain visiting Barcelona and Madrid'}>
                        Plan my Spain Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
